var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDependent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 28",
    style: {
      enableBackground: "new 0 0 14 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#424242;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.3,6.9c1.4,0,2.5-1.1,2.5-2.5c0-1-0.6-1.9-1.5-2.3c0.2-0.2,0.3-0.5,0.3-0.8C8.7,0.6,8.1,0,7.3,0S6,0.6,6,1.3 c0,0.3,0.1,0.6,0.3,0.8C5.4,2.5,4.8,3.4,4.8,4.4C4.8,5.8,6,6.9,7.3,6.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,14.7L12,7.1c-0.1-0.5-0.5-0.8-1-0.9h-0.7c-0.6,1-1.7,1.6-2.9,1.6S5,7.2,4.4,6.2H3c-0.5,0-0.9,0.4-1,0.9 l-1.7,7.7c-0.1,0.5,0.1,1,0.6,1.3v1C0.3,17.3,0,17.8,0,18.3v3.1c0,0.7,0.6,1.4,1.3,1.4c0.8,0,1.5-0.6,1.5-1.4v-3.2 c0-0.6-0.3-1.1-0.8-1.3v-1c0.3-0.2,0.5-0.4,0.6-0.8l1.3-5.8v2.8l-0.8,6c0,0.2,0,0.5,0.2,0.7c0.2,0.2,0.4,0.3,0.6,0.3v7.3 c0,0.7,0.6,1.4,1.3,1.4c0.8,0,1.5-0.6,1.5-1.4v-6.9c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5v6.8c0,0.7,0.6,1.4,1.3,1.4 c0.8,0,1.5-0.6,1.5-1.4v-7.3c0.2,0,0.5-0.1,0.6-0.3c0.2-0.2,0.2-0.4,0.2-0.7l-0.8-6V10l1.3,5.3c0.1,0.5,0.6,0.9,1.1,0.9 c0.1,0,0.2,0,0.3,0C13.7,16,14.1,15.4,14,14.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDependent);
export default __webpack_public_path__ + "static/media/dependent.f1706ad95d2aefb31ed95fb2156e9e2f.svg";
export { ForwardRef as ReactComponent };